import Foryou from "../images/foryou.jpeg";
import RIPLEGEND from "../images/RipLegend.jpeg";


var foryouData = {
  headlines: {
    img: {Foryou},
    subTitle: " News . LIVE",
    Title: " Johnny Depp and Amber Heard defamation trial reaches jury deliberation"

  },
  tweets: [
  {
    subhead: "Bollywood . Trending",
    title: "#Atlee",
    nooftweets: "3,410 Tweets"
  },
  {
    subhead: "Entertainment . Trending",
    title: "#MenToo",
    nooftweets: "46.2K Tweets"
  },{
    subhead: "Trending in India",
    title: "#RIPLegend",
    nooftweets: "9,420 Tweets",
    img: {RIPLEGEND}
  },
  {
    subhead: "Celebrities . Trending",
    title: "HE DID IT",
    nooftweets: "151K Tweets"
  },
  {
    subhead: "Trending in Actors",
    title: "#BleliveAllWomen",
    nooftweets: "15.3K Tweets"
  }]
};
export default foryouData;
